// extracted by mini-css-extract-plugin
export default {"input_block":"addCategory_input_block__BvtcT","input_block_title":"addCategory_input_block_title__7s6NF"};